"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bagni-di-lucca": {
    "3f62e372": [{
      "hkey": "eb1e953a",
      "slug": "palleggio-cocciglia",
      "name": "Palleggio-Cocciglia",
      "primary": true,
      "skipSearch": false
    }],
    "cocciglia": [{
      "hkey": "eb1e953a",
      "slug": "palleggio-cocciglia",
      "name": "Palleggio-Cocciglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bagni-di-lucca"
    }],
    "b5573993": [{
      "hkey": "eb1e953a",
      "slug": "palleggio-cocciglia",
      "name": "Palleggio-Cocciglia",
      "primary": true,
      "skipSearch": false
    }],
    "palleggio": [{
      "hkey": "eb1e953a",
      "slug": "palleggio-cocciglia",
      "name": "Palleggio-Cocciglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b46788ac": [{
      "hkey": "fa91c44c",
      "slug": "guzzano-pieve-di-controni",
      "name": "Guzzano-Pieve di Controni",
      "primary": true,
      "skipSearch": false
    }],
    "pieve-di-controni": [{
      "hkey": "fa91c44c",
      "slug": "guzzano-pieve-di-controni",
      "name": "Guzzano-Pieve di Controni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1aa4520c": [{
      "hkey": "1135cac5",
      "slug": "centro-ponte-a-serraglio",
      "name": "Centro-Ponte a Serraglio",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-a-serraglio": [{
      "hkey": "1135cac5",
      "slug": "centro-ponte-a-serraglio",
      "name": "Centro-Ponte a Serraglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;